<template>
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 4.00005H0V6.00005H9V4.00005ZM9 12.0001H0V14.0001H9V12.0001ZM14.34 8.00005L10.8 4.46005L12.21 3.05005L14.33 5.17005L18.57 0.930054L20 2.34005L14.34 8.00005ZM14.34 16.0001L10.8 12.4601L12.21 11.0501L14.33 13.1701L18.57 8.93005L20 10.3401L14.34 16.0001Z" fill="currentColor"/>
  </svg>
</template>
